import { SidebarTrigger } from '@lms/ui/sidebar';
import { cn } from '@lms/ui/utils';
import { Link } from 'react-router-dom';
import type { Site } from '@/features/branding/brand-provider';

// Ports components/mobile-header.tsx: the top bar shown only on small screens,
// with the sidebar toggle and the brand logo.
function MobileHeader({ site }: { site: Site }) {
  return (
    <div
      className={cn(
        'absolute top-0 right-0 left-0 z-10 -mb-12 flex h-12 flex-row items-center justify-between gap-4 border-b bg-white p-2 md:hidden',
      )}
    >
      <SidebarTrigger />
      <Link
        to={`/${site.slug}/admin`}
        className="flex items-center gap-2 text-lg font-semibold md:text-base"
      >
        <img
          src={site.logo}
          className="mx-auto h-full max-h-8 w-full max-w-32 object-scale-down transition-all"
          alt={site.name}
        />
        <span className="sr-only">{site.name}</span>
      </Link>
      <div className="size-8" />
    </div>
  );
}
MobileHeader.displayName = 'MobileHeader';

export { MobileHeader };
